export default "__VITE_ASSET__BkOvW178__"